// extracted by mini-css-extract-plugin
module.exports = {"title":"b7ab3","tagline":"_63f21","tags":"_86f70","buttons":"_76f8e","button":"_1bdfa"};